import { useEventCallback } from '@cian/react-utils';
import { useEffect, useState } from 'react';
import { EXPANDED_HEIGHT_DEFAULT } from '../constants';
export const useExpandedHeight = contentRef => {
  const [expandedHeight, setExpandedHeight] = useState(EXPANDED_HEIGHT_DEFAULT);
  const updateHeight = useEventCallback(() => {
    const contentElement = contentRef.current;
    setExpandedHeight(contentElement.scrollHeight);
  });
  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [updateHeight]);
  return expandedHeight;
};